import React, { useEffect, useState } from "react";
import { Grid, Container, TableCell, Card, TableContainer, Stack, Avatar, Typography, FormControl, Select, MenuItem, Button, Dialog, DialogTitle, DialogContent, TextField, Tooltip, CardMedia, CardContent, Stepper, Box, Paper, StepLabel, Step, Chip } from '@mui/material';
import { toast } from "react-toastify";
import { getData, postData } from "src/webService/webService";
import { useNavigate, useParams } from "react-router-dom";
import Iconify from "src/components/iconify";
import whatsappIcon from 'src/components/icons/whatsapp (1).png';

export default function Analytics() {

    const pathParts = window.location.pathname.split('/');
    const id = pathParts[4];
    const Token = sessionStorage.getItem('Token');
    const [getHistory, setGetHistory] = useState([]);
    const [callRequest, setCallRequest] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [limitRequest, setLimitRequest] = useState(10);
    const [currentPageRequest, setCurrentPageRequest] = useState(1);
    const [totalPagesRequest, setTotalPagesRequest] = useState(1)
    const [TotalItemsRequest, setTotalItemsRequest] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [report, setReport] = useState('');
    const [buyerId, setBuyerId] = useState('');
    const role = sessionStorage.getItem('Role');
    const [getAnalysisData, setGetAnalysisData] = useState({});
    const [brandId, setBrandId] = useState(id)
    const [activeStep, setActiveStep] = useState(0);
    // const [showDashboard, setShowDashboard] = useState(false);

    //brand states
    const [brandList, setBrandList] = useState([]);
    const [brandName, setbrandName] = useState('');

    const navigate = useNavigate();

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    console.log(currentPageRequest, 'currentpagerequest');


    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleOpenModal = (id) => {
        setOpenModal(true);
        setBuyerId(id);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    const handleLimitChangeRequest = (event) => {
        setCurrentPageRequest(1);
        setLimitRequest(event.target.value);
    };

    const handlePrevPageRequest = () => {
        if (currentPageRequest > 1) {
            setCurrentPageRequest(currentPageRequest - 1);
        }
    };

    const handleNextPageRequest = () => {
        if (currentPageRequest < totalPagesRequest) {
            setCurrentPageRequest(currentPage + 1);
        }
    };

    const getAnalysis = async (id) => {
        try {

            const res = await getData(`seller/${id}/analytics`, null, Token);
            if (res.status === 200) {
                console.log(res, "res.data");
                setGetAnalysisData(res);
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        const brandName = decodeURIComponent(pathParts[5]);
        setbrandName(brandName)

        if (brandId && brandName) {
            getAnalysis(brandId, brandName);
        }
    }, []);



    const getHistoryData = async (page) => {
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            const res = await getData(`seller/${brandId}/history`, params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setGetHistory(res?.data);
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }



    const postReport = () => {
        debugger;
        const params = {
            reason: report
        }

        postData(`seller/report/${buyerId}`, params, Token)
            .then((res) => {
                toast.success(res?.message);
                setGetHistory(currentPage);
                getCallRequestData(currentPageRequest);
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error(error);
            });

        handleClose();
    }


    const getCallRequestData = async (page) => {
        debugger;
        const params = {
            page: page,
            per_page: limitRequest,
        }
        try {
            const res = await getData(`seller/${brandId}/requests`, params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCallRequest(res?.data);
                setTotalItemsRequest(res?.total);
                setTotalPagesRequest(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        if (role === 'Seller') {
            getCallRequestData(currentPageRequest);
        }
    }, [limitRequest, role, currentPageRequest]);

    useEffect(() => {
        if (role === 'Seller') {
            getHistoryData(currentPage);
        }
    }, [limit, role, currentPage]);


    const handleBackToDashboard = () => {
        navigate('/seller/app')
    }


    return (
        <>
            <div className='GoToDash' maxWidth="xl">
                <div className='d-flex justify-content-between'>
                    <h3>{brandName}</h3>
                    <Button variant='contained' size="small" sx={{ padding: '10px 20px', marginBottom: '10px', backgroundColor: 'black', color: 'white' }} onClick={handleBackToDashboard}>Back</Button>
                </div>
                <Grid container spacing={3}>

                    <Grid item xs={12} md={6} lg={3}>
                        <div className='dashboardCard'>
                            <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Views</p>
                            <h4>{getAnalysisData?.views ? getAnalysisData?.views : 0}</h4>
                            <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_views ? getAnalysisData?.recent_views : 0}</b> Views in last 7 days</p>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <div className='dashboardCard'>
                            <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Calls</p>
                            <h4>{getAnalysisData?.calls ? getAnalysisData?.calls : 0}</h4>
                            <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_calls ? getAnalysisData?.recent_calls : 0}</b> Calls in last 7 days</p>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <div className='dashboardCard'>
                            <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:message-square-outline" />Total Chat</p>
                            <h4>{getAnalysisData?.chats ? getAnalysisData?.chats : 0}</h4>
                            <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_chats ? getAnalysisData?.recent_chats : 0}</b> Chats in last 7 days</p>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6} lg={3}>
                        <div className='dashboardCard'>
                            <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Callback Request</p>
                            <h4>{getAnalysisData?.callback_requests ? getAnalysisData?.callback_requests : 0}</h4>
                            <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_callback_requests ? getAnalysisData?.recent_callback_requests : 0}</b> Callback in last 7 days</p>
                        </div>
                    </Grid>




                    <Grid item xs={12} md={6} lg={6}>
                        <Card>
                            <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                                <Typography variant="h6" style={{ fontSize: '1rem' }} className='title-color' gutterBottom>
                                    History
                                </Typography>
                            </Stack>
                            <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                                {getHistory?.map((item, index) => (
                                    <div className="p-2 mb-3 profileCard">
                                        <div className='row'>
                                            <div className='col-lg-2'>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                >
                                                    {item?.buyer?.profile_picture ? (
                                                        <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                                    ) : (
                                                        <Avatar style={{ width: '60px', height: '60px' }}>
                                                            {item?.buyer?.name
                                                                ? item?.buyer?.name[0]
                                                                : null}
                                                        </Avatar>
                                                    )}
                                                </Stack>
                                            </div>
                                            <div className='col-lg-6 d-flex align-items-center'>
                                                <div>
                                                    <h6 className='d-flex align-items-center'>{item?.buyer?.name}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} className='pointer' onClick={(e) => handleOpenModal(item?.buyer?._id)} icon="eva:alert-circle-outline" /></Tooltip></h6>
                                                    <p className='fs-14 mb-0'>{item?.buyer?.location}</p>
                                                </div>
                                            </div>

                                            <div className='col-lg-4 d-flex align-items-center justify-content-center'>
                                                <div>
                                                    <p className='fs-14 mb-0'>Type: <b>{item?.type}</b></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </TableContainer>
                            <div className="d-flex flex-wrap justify-content-end m-3">
                                <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                                    <Select
                                        labelId="limit-label"
                                        id="limit-select"
                                        value={limit}
                                        onChange={handleLimitChange}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={TotalItems}>All</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <Iconify icon={"grommet-icons:previous"} />
                                </Button>
                                <Button
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                >
                                    <Iconify icon={"grommet-icons:next"} />
                                </Button>
                            </div>
                        </Card>
                    </Grid>


                    <Grid item xs={12} md={6} lg={6}>
                        <Card>
                            <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                                <Typography variant="h6" className='title-color' style={{ fontSize: '1rem' }} gutterBottom>
                                    Call Requests
                                </Typography>
                            </Stack>
                            <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                                {callRequest?.map((item, index) => (
                                    <div className="p-2 mb-3 profileCard">
                                        <div className='row'>
                                            <div className='col-lg-2'>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                >
                                                    {item?.buyer?.profile_picture ? (
                                                        <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                                    ) : (
                                                        <Avatar style={{ width: '60px', height: '60px' }}>
                                                            {item?.buyer?.name
                                                                ? item?.buyer?.name[0]
                                                                : null}
                                                        </Avatar>
                                                    )}
                                                </Stack>
                                            </div>
                                            <div className='col-lg-5 d-flex align-items-center'>
                                                <div>
                                                    <h6 className='d-flex align-items-center'>{item?.buyer?.name ? item?.buyer?.name : 'Name Not Available'}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} onClick={(e) => handleOpenModal(item?.buyer?._id)} className='pointer' icon="eva:alert-circle-outline" /></Tooltip></h6>
                                                    <p className='fs-14 mb-0'>{item?.buyer?.location ? item?.buyer?.location : 'Location Not Available'}</p>
                                                </div>
                                            </div>

                                            <div className='col-lg-5 d-flex align-items-center justify-content-center'>
                                                <div>
                                                    <a href={`tel:${item?.buyer?.phone}`} style={{ textDecoration: 'none', color: '#212B36' }}>
                                                        <p className='fs-14 mb-2'><Iconify style={{ marginRight: '12px' }} icon={"eva:phone-outline"} /><b> {item?.buyer?.phone ? item?.buyer?.phone : 'Not Available'}</b></p>
                                                    </a>
                                                    <a
                                                        href={`https://wa.me/${item?.buyer?.whatsapp}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: '#212B36' }}
                                                    >
                                                        <p className="fs-14 d-flex align-items-center mb-0"><img style={{ marginRight: '14px', width: '11%' }} src={whatsappIcon} /><b>{item?.buyer?.whatsapp ? item?.buyer?.whatsapp : 'Not Available'}</b></p>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </TableContainer>
                            <div className="d-flex flex-wrap justify-content-end m-3">
                                <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                                    <Select
                                        labelId="limit-label"
                                        id="limit-select"
                                        value={limitRequest}
                                        onChange={handleLimitChangeRequest}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={TotalItemsRequest}>All</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button onClick={handlePrevPageRequest} disabled={currentPageRequest === 1}>
                                    <Iconify icon={"grommet-icons:previous"} />
                                </Button>
                                <Button
                                    onClick={handleNextPageRequest}
                                    disabled={currentPageRequest === totalPagesRequest}
                                >
                                    <Iconify icon={"grommet-icons:next"} />
                                </Button>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </div>

            <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Report Buyer</DialogTitle>
                <DialogContent>
                    <Grid item xs={12} className='mt-3'>
                        <TextField
                            className="w-100"
                            id="outlined-basic"
                            value={report}
                            onChange={(e) => setReport(e.target.value)}
                            label="Report *"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <div className='mt-4 d-flex justify-content-end'>
                        <Button variant="contained" className='Button' onClick={postReport}>
                            Submit
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}